import { Injectable, TemplateRef, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';

import {
  DialogComponent,
  DialogFormComponent,
  DialogInfoComponent,
} from '../../components';

@Injectable({ providedIn: 'root' })
export class DialogService {
  private readonly _dialog: MatDialog = inject(MatDialog);
  private readonly _router: Router = inject(Router);

  constructor() {
    this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this._dialog.closeAll();
      }
    });
  }

  confirm(message: string, dialogConfig: MatDialogConfig = {}) {
    return this._dialog.open(DialogComponent, {
      ...dialogConfig,
      data: {
        message,
      },
    });
  }

  form<T>(
    template: TemplateRef<T>,
    form: FormGroup | FormControl,
    dialogConfig: MatDialogConfig = {}
  ) {
    const dialog = this._dialog.open(DialogFormComponent, {
      ...dialogConfig,
      data: {
        ...dialogConfig.data,
        template,
        form,
      },
    });

    return dialog;
  }

  info<T>(template: TemplateRef<T>, dialogConfig: MatDialogConfig = {}) {
    const dialog = this._dialog.open(DialogInfoComponent, {
      ...dialogConfig,
      data: {
        ...dialogConfig.data,
        template,
        context: dialogConfig.data?.context || null,
      },
    });

    return dialog;
  }
}
